<template>
  <div>
    <div v-for="(infoPopup, index) in infoPopups" :key="index">
      <PopupInfo
        :img="infoPopup.img"
        :id="infoPopup.id"
        :title="infoPopup.title"
        :text="infoPopup.text"
        :text2="infoPopup.text2"
      />
    </div>
  </div>
</template>

<script>
import PopupInfo from './PopupInfo'

export default {
  name: 'popups',
  components: {
    PopupInfo,
  },
  methods: {
    bindInfoPoups() {
      document.addEventListener('click', (event) => {
        const target = event.target
        if (target && target.hasAttribute('data-info-popup')) {
          const id = target.getAttribute('data-info-popup')
          if (id) {
            this.$root.$emit('bv::show::modal', id)
          }
        }
      })
    },
  },
  computed: {
    // To use dynamic content in a popup, commit content
    // to popupContent in the store (store.state.data) and replace the placeholders
    // in the popup text with the replaceDynamicContent function
    // TODO: The setup of this popup component should be simplified in a later phase.
    popupContent() {
      const popupContent = this.$store.state.data.popupContent
      return Object.keys(popupContent).reduce((processedPopupContent, key) => {
        processedPopupContent[key] = this.$options.filters.formatCurrency(popupContent[key])
        return processedPopupContent
      }, {})
    },
    infoPopups() {
      return [
        {
          id: 'wattpiek',
          img: 'wattpiek',
          title: this.content.pv_slider_wattpiek_title,
          text: this.content.pv_slider_wattpiek_text,
        },
        {
          id: 'production',
          img: 'production',
          title: this.content.pv_slider_production_title,
          text: this.content.pv_slider_production_text,
        },
        {
          id: 'paybacktime',
          img: 'panels-color',
          title: this.content.pv_slider_paybacktime_title,
          text: this.content.pv_slider_paybacktime_text,
        },
        {
          id: 'arei',
          img: 'arei',
          title: this.content.pv_slider_arei_title,
          text: this.content.pv_slider_arei_text,
        },
        {
          id: 'assembly',
          img: 'assembly',
          title: this.content.pv_slider_assembly_title,
          text: this.content.pv_slider_assembly_text,
        },
        {
          id: 'environment',
          img: 'panels-color',
          title: this.content.pv_slider_environmentalprofit_title,
          text: this.content.pv_slider_environmentalprofit_text,
        },
        {
          id: 'installation',
          img: 'installation',
          title: this.content.pv_slider_installation_title,
          text: this.content.pv_slider_installation_text,
        },
        {
          id: 'production_meter',
          img: 'production-meter',
          title: this.content.pv_slider_production_meter_title,
          text: this.content.pv_slider_production_meter_text,
        },
        {
          id: 'sun-inspection',
          img: 'sun-inspection',
          title: this.content.pv_infoblock_installation_list_item_sun_inspection_title,
          text: this.content.pv_infoblock_installation_list_item_sun_inspection_text,
        },
        {
          id: 'price-disclaimer',
          img: 'thumbs-up',
          title: this.content.pv_price_disclaimer_title,
          text: this.content.pv_price_disclaimer,
        },
        {
          id: 'cleaning-panels',
          img: 'panel-cleaning-icon',
          title: this.content.cleaning_16_panels_title,
          text: this.$options.filters.replaceDynamicContent(
            this.content.cleaning_16_panels_shorttext_with_link
          ),
        },
        {
          id: 'no_production_meter',
          img: 'production-meter',
          title: this.content.pv_sunsure_and_production_meter,
          text: this.content.pv_sunsure_and_production_meter_info,
        },
        {
          id: 'pv-subsidy',
          img: 'subsidy-icon',
          title: this.content.pv_savings_pv_subsidy_modal_title,
          text: this.content.pv_savings_pv_subsidy_modal_text,
        },
        {
          id: 'battery-subsidy',
          img: 'subsidy-icon',
          title: this.content.pv_savings_battery_subsidy_modal_title,
          text: this.content.pv_savings_battery_subsidy_modal_text,
        },
        {
          id: 'battery-subsidy-with-disclaimer',
          img: 'subsidy-icon',
          title: this.content.pv_savings_battery_subsidy_modal_title,
          text: this.content.pv_savings_battery_subsidy_modal_text,
          text2: this.content.detail_calculation_disclaimer,
        },
        {
          id: 'twenty-five-year-calculation-explanation',
          img: 'pen-paper-icon',
          title: this.content.twenty_five_year_calculation_modal_title,
          text: this.content.twenty_five_year_calculation_modal_text,
        },
        {
          id: 'downpayment',
          img: 'downpayment',
          title: this.content.downpayment_modal_title,
          text: this.content.downpayment_modal_text,
        },
        {
          id: 'co2CalculationPopup',
          img: 'house-illustration',
          title: this.content.environmental_gains_co2_popup_title,
          text: this.content.environmental_gains_co2_popup_text,
        },
        {
          id: 'kmsCalculationPopup',
          img: 'monitoring-car',
          title: this.content.environmental_gains_kms_popup_title,
          text: this.content.environmental_gains_kms_popup_text,
        },
        {
          id: 'treesCalculationPopup',
          img: 'trees-illustration',
          title: this.content.environmental_gains_trees_popup_title,
          text: this.content.environmental_gains_trees_popup_text,
        },
      ]
    },
  },
  created() {
    this.bindInfoPoups()
  },
  mounted() {
    this.bindInfoPoups()
  },
}
</script>
